import { render } from "./UpdateTask.vue?vue&type=template&id=6b9318cc&scoped=true"
import script from "./UpdateTask.vue?vue&type=script&lang=js"
export * from "./UpdateTask.vue?vue&type=script&lang=js"

import "./UpdateTask.vue?vue&type=style&index=0&id=6b9318cc&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9318cc"]])

export default __exports__